import { render, staticRenderFns } from "./EventiImmaginiViewComponent.vue?vue&type=template&id=5db6faf2"
import script from "./EventiImmaginiViewComponent.vue?vue&type=script&lang=js"
export * from "./EventiImmaginiViewComponent.vue?vue&type=script&lang=js"
import style0 from "./EventiImmaginiViewComponent.vue?vue&type=style&index=0&id=5db6faf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports